import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import ActivityDownloadsTab from "./innertabs/ActivityDownloads";
import ActivityOpportunitiesTab from "./innertabs/ActivitiyOpportunities";
import ActivityOrdersTab from "./innertabs/ActivityOrders";
import ActivityDashboardTab from "./innertabs/ActivityDashboard";
import {
  DashboardIcon,
  DownloadPackageIcon,
  OpportunitiesIcon,
  OrdersIcon,
} from "../../../../icons";
import { useNitroStore } from "../../../../store/Store";

const ActivityTab = () => {
  const [tab, setTab] = useNitroStore((state) => [
    state.insightsActivityTab,
    state.setInsightsActivityTab,
  ]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      {/* INNER TABS (SIN) */}
      <div
        style={{
          borderBottom: "2px solid #D9D9D9",
          width: "100%",
          paddingLeft: 20,
        }}
      >
        <BottomNavigation
          style={{ height: 80, width: 400 }}
          showLabels
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
        >
          <BottomNavigationAction
            label="Dashboard"
            value="Dashboard"
            icon={
              <DashboardIcon
                color={tab === "Dashboard" ? "#005CA6" : "rgb(0,0,0,.6)"}
              />
            }
          />
          <BottomNavigationAction
            label="Orders"
            value="Orders"
            icon={
              <OrdersIcon
                color={tab === "Orders" ? "#005CA6" : "rgb(0,0,0,.6)"}
              />
            }
          />
          <BottomNavigationAction
            label="Opportunities"
            value="Opportunities"
            icon={
              <OpportunitiesIcon
                color={tab === "Opportunities" ? "#005CA6" : "rgb(0,0,0,.6)"}
              />
            }
          />
          <BottomNavigationAction
            label="Downloads"
            value="Downloads"
            icon={
              <DownloadPackageIcon
                color={tab === "Downloads" ? "#005CA6" : "rgb(0,0,0,.6)"}
              />
            }
          />
        </BottomNavigation>
      </div>

      {/* BODY */}

      <div
        style={{
          display: "flex",
          flexGrow: 1,
          minHeight: 0,
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: 10,
            paddingBottom: 20,
            paddingRight: 10,
            width: "100%",
          }}
        >
          {tab === "Dashboard" && <ActivityDashboardTab />}
          {tab === "Orders" && <ActivityOrdersTab />}
          {tab === "Opportunities" && <ActivityOpportunitiesTab />}
          {tab === "Downloads" && <ActivityDownloadsTab />}
        </div>
      </div>
    </div>
  );
};

export default ActivityTab;
